import { defineStore } from 'pinia';
import { type IStrapiImage } from '~/types/strapiImage';
import { assignDataToFields, createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';

export const useStoreHeader = defineStore('header', {
  state: () => ({
    logo: {} as IStrapiImage,
    logoMobile: {} as IStrapiImage,
    balanceTitle: '',
    bonusesTitle: '',
    profileTitle: '',
    signOutTitle: '',
    converterTitle: '',
    historyTitle: '',
    equalsTitle: '',
    documentsTitle: '',
    rewardText: '',
    toVipTitle: '',
    profileButtonTitle: '',
    locale: '',
    pendingWithdrawalText: '',
    amountWithdrawalText: '',
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadHeader() {
      if (!this.requestPromise) {
        const populateString = createPopulateString(['logo', 'logoMobile']);

        this.requestPromise = strapi()
          .get('header', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
